import React from 'react'
import { InputNumber } from 'primereact/inputnumber'
import { Dialog } from 'primereact/dialog'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import ConstantsUtil from '../../context/constantsUtil'
import { Button } from 'primereact/button'
import AuthService from '../../app/service/authService'
import ProvisaoService from '../../app/service/contasAPagar/provisaoService'
import HandleErrorService from '../../app/service/handleErrorService'
import DialogFooter from '../dialogFooter'
import InputChooseTipoDePagamento from './inputChooseTipoDePagamento'
import * as popUp from '../toastr'
import InputChooseTipoDeDesconto from './provisoes/inputChooseTipoDeDesconto'
import GeneralServices from '../../app/service/generalServices'
import { InputTextarea } from 'primereact/inputtextarea'
import TooltipButton from '../tooltipButton'
import ConfirmationDialog from '../confirmationDialog'

class InputValorAcrescimoDescontoParcelaProvisaoComponent extends React.Component {

    constructor(){
        super()
        this.inputTextObservacaoRef = React.createRef()
        this.provisaoService = new ProvisaoService()
        this.generalServices = new GeneralServices()
    }

    state = { 

        displayDialog: false,

        displayCreateEditDialog: false,

        createOrEditAcrescimoLabel: '',

        acrescimoDescontoList: [],

        selectedTipoDePagamento: null,
        selectedTipoDePagamentoLabel: '',
        inputTipoDePagamentoErrorClass: '',
        
        selectedTipoDeDesconto: null,
        inputTipoDeDescontoErrorClass: '',
        
        valor: null,
        inputValorErrorClass: '',

        idAcrescimoOuDescontoToEdit: '',
        
        idAcrescimoOuDescontoToDelete: '',
        displayConfirmDeleteAcrescimoDescontoDialog: false,
        

    }

    inputClick = () => {
        if(this.props.disabled){
            //Ocorre no DRE por Competênica Unificado, por exemplo
            popUp.infoPopUp("Não é permitido adicionar acréscimos/descontos por esta tela.")
            return
        }
        this.setState({displayDialog: true})
        this.search()
    }

    hideDialog = async () => {
        this.setState({
            displayDialog: false,
            acrescimoDescontoList: []
        })

        if(this.props.hideDialog){
            this.props.hideDialog()
        }

        
        if(this.props.reRenderEditDialog){
            await this.generalServices.sleep(200)
            this.props.reRenderEditDialog()
        }
    }

    search = () => {
        AuthService.startBlockUi()
        this.provisaoService.buscaAcrescimoDescontoParcelaProvisao(
            this.props.idParcelaProvisao,
            this.props.isAcrescimo ? ConstantsUtil.acrescimo : ConstantsUtil.desconto
        )
        .then(response => {
            this.setState({acrescimoDescontoList: response.data.acrescimoDescontoList})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    openDialog = async () => {
        await this.setState({
            displayCreateEditDialog: true,
            createOrEditAcrescimoLabel: `Adicionar ${this.props.isAcrescimo ? "Acréscimo" : "Desconto"}`
        })
    }

    adicionarAcrescimoOuDesconto = () => {
        this.openDialog()
    }
    
    hideCreateEditDialog = () => {
        this.setState({
            displayCreateEditDialog: false,
            selectedTipoDePagamento: '',
            selectedTipoDePagamentoLabel: '',
            selectedTipoDeDesconto: '',
            valor: '',
            idAcrescimoOuDescontoToEdit: '',
            idAcrescimoOuDescontoToDelete: '',
        })
    }

    handleSelectionTipoDePagamentoChange = async (tipoDePagamento, label) => {

        await this.setState({selectedTipoDePagamento: tipoDePagamento})
        await this.setState({selectedTipoDePagamentoLabel: label})

    }

    handleValorChange = (event) => {
        this.setState({valor: event.target.value})
    }

    resetView = () => {
        this.setState({
            inputTipoDePagamentoErrorClass: '',
            inputTipoDeDescontoErrorClass: '',
            inputValorErrorClass: ''
        })
    }

    checkData = () => {
        var check = true

        // console.log("this.state: ", this.state)

        if(this.props.isAcrescimo && !this.state.selectedTipoDePagamento){
            this.setState({inputTipoDePagamentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(this.props.isDesconto && !this.state.selectedTipoDeDesconto){
            this.setState({inputTipoDeDescontoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(!this.state.valor){
            this.setState({inputValorErrorClass: ConstantsUtil.primereactInputErrorClass})
            check = false            
        }

        return check
    }

    callSave = () => {
        this.resetView()
        if(this.checkData()){
            this.save()
        }
    }

    save = () => {

        AuthService.startBlockUi()

        let body = {
            id: this.state.idAcrescimoOuDescontoToEdit ? this.state.idAcrescimoOuDescontoToEdit : null,
            tipoDeDesconto: this.state.selectedTipoDeDesconto ? this.state.selectedTipoDeDesconto : null,
            tipoDePagamento: this.state.selectedTipoDePagamento ? this.state.selectedTipoDePagamento : null,
            valor: this.state.valor,
            idParcelaProvisao: this.props.idParcelaProvisao,
            tipo: this.props.isAcrescimo ? ConstantsUtil.acrescimo : ConstantsUtil.desconto,
            observacao: this.inputTextObservacaoRef.current.value
        }

        // console.log("body: ", body)
        this.provisaoService.saveAcrescimoDesconto(body)
        .then(response => {
            popUp.successPopUp(`Registro ${this.state.idAcrescimoOuDescontoToEdit ? 'editado' : 'criado'} com sucesso!`)
            this.hideCreateEditDialog()
            this.search()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
        AuthService.stopBlockUi()
        })
    }

    callEdit = async acrescimoOuDesconto => {
        // console.log("callEdit: ", acrescimoOuDesconto)
        await this.setState({
            idAcrescimoOuDescontoToEdit: acrescimoOuDesconto.id,
            
            selectedTipoDeDescontoLabel: acrescimoOuDesconto.tipo === ConstantsUtil.descontoLabel ? acrescimoOuDesconto.tipoDeDesconto.descricao : '',
            selectedTipoDeDesconto: acrescimoOuDesconto.tipo === ConstantsUtil.descontoLabel ? acrescimoOuDesconto.tipoDeDesconto : '',
            
            selectedTipoDePagamentoLabel: acrescimoOuDesconto.tipo === ConstantsUtil.acrescimoLabel ? acrescimoOuDesconto.tipoDePagamento.nome : '',
            selectedTipoDePagamento: acrescimoOuDesconto.tipo === ConstantsUtil.acrescimoLabel ? acrescimoOuDesconto.tipoDePagamento : '',
            
            valor: acrescimoOuDesconto.valor,
        })
        await this.openDialog()
        // console.log("this.inputTextObservacaoRef: ", this.inputTextObservacaoRef)
        this.inputTextObservacaoRef.current.value = acrescimoOuDesconto.observacao
    }

    callDelete = (acrescimoOuDesconto) => {
        this.setState({
            idAcrescimoOuDescontoToDelete: acrescimoOuDesconto.id,
            displayConfirmDeleteAcrescimoDescontoDialog: true
        })
    }

    confirmDelete = () => {
        this.provisaoService.deleteAcrescimoDesconto(this.state.idAcrescimoOuDescontoToDelete)
        .then(response => {
            popUp.successPopUp(`Registro deletado com sucesso!`)
            this.hideConfirmDeleleAcrescimoDesconto()
            this.search()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    hideConfirmDeleleAcrescimoDesconto = () => {
        this.setState({
            idAcrescimoOuDescontoToDelete: '',
            displayConfirmDeleteAcrescimoDescontoDialog: false
        })
    }

    handleTipoDeDescontoChange = async selectedTipoDeDesconto => {
        // console.log("handletipoDeDescontoChange: ", tipoDeDesconto)
        await this.setState({selectedTipoDeDesconto})
    }    

    getDescricaoTipoDeDesconto = () => {
        let descricao = this.state.selectedTipoDeDesconto && this.state.selectedTipoDeDesconto.descricao ? this.state.selectedTipoDeDesconto.descricao : ''
        return descricao
    }

    render(){

        const renderTipoDePagamentoColumn = () => {
            if(this.props.isAcrescimo){
                return (
                    <Column
                        header="Tipo de Pagamento"
                        field="tipoDePagamento.nome"
                        sortable
                        style ={ {width: '200px'} }
                    />
                )
            }
        }

        const renderTipoDeDescontoColumn = () => {
            if(this.props.isDesconto){
                return (
                    <Column
                        header="Tipo de Desconto"
                        field="tipoDeDesconto.descricao"
                        sortable
                        style ={ {width: '200px'} }
                    />
                )
            }
        }

        const renderActionColumn = () => {
            return (
                <Column header="Ações" body={actionBody} style ={ {width: "100px"} }
                />
            )
        }

        const actionBody = (acrescimoOuDesconto) => {
            return (
                <React.Fragment>
                    <TooltipButton
                        tooltip='Editar'
                        icon="pi pi-pencil"
                        onClick={() => this.callEdit(acrescimoOuDesconto)}
                    />

                    <TooltipButton
                        tooltip='Excluir'
                        className={ "p-button-rounded p-button-danger p-mr-2 right-button" }
                        icon="pi pi-times"
                        onClick={() => this.callDelete(acrescimoOuDesconto)}
                    />

                </React.Fragment>
            );
        }

        const renderConfirmDeleteAcrescimoDescontoDialog = () => {
            return(
                <ConfirmationDialog
                    visible={this.state.displayConfirmDeleteAcrescimoDescontoDialog}
                    header={"Deletar"}
                    confimationMessage={ "Deseja Confirmar?"}
                    confirm={this.confirmDelete}
                    hide={this.hideConfirmDeleleAcrescimoDesconto}
                />
            )
        }        

        const renderTable = () => {

            return (

                <DataTable
                    ref={this.dt}
                    value={this.state.acrescimoDescontoList}
                    className="p-datatable-sm small-font"
                    rowHover
                    emptyMessage={`Não há ${this.props.isAcrescimo ? "acréscimos" : "descontos"}`}
                    showGridlines
                    selection={this.state.selectedFormaDePagamento}
                    onSelectionChange={this.handleSelectionChange}
                    loading={this.state.loadingTable}
                    dataKey="id"
                >

                    {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }} /> */}

                    <Column
                        header="Tipo"
                        field="tipo"
                        sortable
                        style ={ {width: '200px'} }
                        // filter filterElement={perfilFilterElement}
                    />

                    {renderTipoDePagamentoColumn()}

                    {renderTipoDeDescontoColumn()}

                    <Column
                        header="Valor"
                        field="valor"
                        sortable
                        style ={ {width: '200px'} }
                        body={rowData => GeneralServices.valueBodyTemplateWithCifrao(rowData.valor)}
                        // filter filterElement={perfilFilterElement}
                    />

                    <Column
                        header="Observação"
                        field="observacao"
                        sortable
                        style ={ {width: '200px'} }
                        // filter filterElement={perfilFilterElement}
                    />

                    {/* <Column header="Editar" body={actionBody} style ={ {width: '140px'} } /> */}
                    {renderActionColumn()}

                </DataTable>

            )
        }

        const renderDialog = () => {
            return (
                <Dialog
                    header={`${this.props.isAcrescimo ? "Acréscimos" : "Descontos"}`}
                    visible={this.state.displayDialog}
                    modal
                    style={{ width: '90vw' }}
                    onHide={this.hideDialog}
                >

                    <Button
                        label={`Adicionar ${this.props.isAcrescimo ? 'Acréscimo' : 'Desconto'}`}
                        icon="pi pi-plus"
                        className=" small-font"
                        style={{maxHeight: '25px', marginLeft: '10px'}}
                        onClick={this.adicionarAcrescimoOuDesconto}
                    />

                    <br />
                    <br />

                    {renderTable()}

                </Dialog>

            )
        }

        const createEditDialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideCreateEditDialog}
            />
        )
        
        const renderCreateEditDialog = () => {
            return(
                <Dialog
                    visible={this.state.displayCreateEditDialog}
                    header={this.state.createOrEditAcrescimoLabel}
                    modal
                    style={{ width: '450px' }}
                    onHide={this.hideCreateEditDialog}
                    footer={createEditDialogFooter}
                >
                    {renderInputChooseTipoDePagamento()}

                    {renderInputChooseTipoDeDesconto()}

                    <br />

                    <label style={{ display: 'block' }}>{`Valor`}</label>
                    <InputNumber
                        className={this.state.inputValorErrorClass}
                        style={{width: '100%'}}
                        value={this.state.valor}
                        onValueChange={this.handleValorChange}
                        mode="decimal" locale="pt-BR" minFractionDigits={2}
                    />
                    <div className="row">
                        <div className="col-md-12">
                        <small className="p-error">{this.state.inputValorErrorClass ? ConstantsUtil.informeValorErrorMenssage: ""}</small>
                        </div>
                    </div>

                <div 
                    style={{marginTop: '1rem'}}
                >
                    <InputTextarea
                        ref={this.inputTextObservacaoRef}
                        rows={3}
                        cols={64}
                        autoResize
                        placeholder={"Escreva uma observação (Opcional)"}
                    />
                </div>

                </Dialog>                
            )
        }

        const renderInputChooseTipoDePagamento = () => {
            if(this.props.isAcrescimo)
            return (
                <InputChooseTipoDePagamento
                    noHTMLFormat
                    selectedTipoDePagamentoLabel={this.state.selectedTipoDePagamentoLabel}
                    selectedTipoDePagamento={this.state.selectedTipoDePagamento}
                    simpleView
                    enableCadastrarButtonInSimpleView                    
                    handleSelectionTipoDePagamentoChange={this.handleSelectionTipoDePagamentoChange}
                    inputTipoDePagamentoErrorClass={this.state.inputTipoDePagamentoErrorClass}
                    provisoesAPagar
                />
            )
        }

        const renderInputChooseTipoDeDesconto = () => {
            if(this.props.isDesconto)
            return (
                <InputChooseTipoDeDesconto
                    selectedTipoDeDescontoLabel={this.getDescricaoTipoDeDesconto()}
                    handleSelectionChange={this.handleTipoDeDescontoChange}
                    inputErrorClass={this.state.inputTipoDeDescontoErrorClass}
                />
            )
        }

        return (
            <>

                <label>{this.props.label}</label>
                <div
                    onClick={this.inputClick}
                    style={{ cursor: 'pointer', display: 'inline-block', width: '100%' }}
                >
                    <InputNumber 
                        style={{backgroundColor: 'gray'}}
                        value={this.props.valor}
                        mode="decimal" locale="pt-BR" minFractionDigits={2}
                        disabled
                    />
                </div>

                {renderDialog()}

                {renderCreateEditDialog()}

                {renderConfirmDeleteAcrescimoDescontoDialog()}

            </>
        )
    }

}

export default InputValorAcrescimoDescontoParcelaProvisaoComponent